let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("77BC6")).then(() => parcelRequire('dmaeZ'));